import React, { Component, useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'

import { getUser, getBusinessInfo, fetchBusinessInfo } from '../../../store/alpha'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import SplitMenuController, { MenuSection, MenuItem } from '../../../shared/ui/SplitMenuController'

import TodayViewController from './TodayViewController'
import TrainingClassListController from './TrainingClassListController'
import TrainingClassDetailController from './TrainingClassDetailController'
import OrderListController from './OrderListController'
import OrderDetailController from './OrderDetailController'
import ProposalDetailController from './ProposalDetailController'
import InviteProviderController from './InviteProviderController'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import TodayIcon from '@material-ui/icons/Today'
import ClassIcon from '@material-ui/icons/Schedule'
import OrderIcon from '@material-ui/icons/Assignment'

const styles = theme => ({
  root: {
  },
  contentView: {
    padding: theme.spacing(2),
    width: '100%',
    position: 'relative'
  }
})

const ContentView = ({ theme, classes }) => {
  return (
    <div className={classes.contentView}>
      <Switch>
        <Route path="/company" exact component={TodayViewController} />
        <Route path="/company/order" exact component={OrderListController} />
        <Route path="/company/order/view/:orderKey" exact component={OrderDetailController} />
        <Route path="/company/order/view/:orderKey/invite" exact component={InviteProviderController} />
        <Route path="/company/order/view/:orderKey/proposal/:proposalKey" exact component={ProposalDetailController} />
        
        <Route path="/company/trainingclass" exact component={TrainingClassListController} />
        <Route path="/company/trainingclass/view/:trainingClassKey" exact component={TrainingClassDetailController} />
      </Switch>      
    </div>
  )
}

const CompanyController = ({ theme, classes, user, business, ...props }) => {

  const navigationContext = useContext(NavigationContext)
  
  const menuList = [
    { title: 'Today', 'icon': TodayIcon, link_to: '/company' },
    { title: 'My Classes', 'icon': ClassIcon, link_to: '/company/trainingclass' },    
    { title: 'Orders', 'icon': OrderIcon, link_to: '/company/order' },
  ]
  
  const path = props.location.pathname
  let activeMenuIndex = menuList.findIndex(item => {
    if (path == item.link_to)
        return true
    if (item.link_to != "/company" && path.startsWith(item.link_to))
        return true
  })
  
  const openLink = (path) => {
    navigationContext.openLink(path)
  }
  
  const hideContent = () => {
    navigationContext.openLink("/company")
  }
  
  return (
    <SplitMenuController
      content={<ContentView theme={theme} classes={classes}/>}
      onHideContent={hideContent}
      >
      <MenuSection
        text={
          <Typography variant='body1' style={{
              fontWeight: 800
            }}
            gutterBottom
            >
            { user.companyInfo ? user.companyInfo.name : '' }
          </Typography>
        }>        
        { menuList.map((m, index) => 
          <MenuItem
            primaryText={m.title}
            icon={m.icon}
            onClick={() => openLink(m.link_to)}
            selected={index == activeMenuIndex}
            />
        )}
      </MenuSection>
    </SplitMenuController>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: getUser(state),
    business: getBusinessInfo(state, '0'),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  return {
  }
}

export default
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CompanyController)
  )
  